module.exports = __webpack_public_path__ + "media/images/emblems/Braunau(Turgovio)-Blazono-d07fb5831c59d3d55c596bfb74d5ca21.png";